import { useMemo } from 'react'

import { TourDefinition } from '@ui/components/Tourtip/Tourtip'

import { TickmillProductType } from '@model/TickmillProductType'

export const useTradingAccountsTour = (enabled = true): TourDefinition | null => {
  const tour = useMemo(() => {
    if (!enabled) {
      return null
    }

    return {
      id: 'trading-accounts-onboarding',
      version: 1,
      products: [TickmillProductType.CFD],
      steps: [
        {
          id: 'intro',
          kind: 'intro',
          target: { kind: 'virtual' },
          preferredPlacement: 'auto',
          header: 'tour.tradingAccounts.intro.header',
          description: 'tour.tradingAccounts.intro.description',
        },
        {
          id: 'live',
          kind: 'regular',
          target: { kind: 'data-attr', key: 'trading.create' },
          preferredPlacement: {
            desktop: 'top-right',
            mobile: 'top-right',
          },
          header: 'tour.tradingAccounts.live.header',
          description: 'tour.tradingAccounts.live.description',
        },
        {
          id: 'demo',
          kind: 'regular',
          target: { kind: 'data-attr', key: 'trading.demoTab' },
          preferredPlacement: {
            desktop: 'top-right',
            mobile: 'top-center',
          },
          header: 'tour.tradingAccounts.demo.header',
          description: 'tour.tradingAccounts.demo.description',
        },
        {
          id: 'outro',
          kind: 'outro',
          target: { kind: 'virtual' },
          preferredPlacement: 'auto',
          header: 'tour.tradingAccounts.outro.header',
          description: 'tour.tradingAccounts.outro.description',
          primaryActionText: 'tour.tradingAccounts.outro.primaryActionText',
          primaryActionCommand: 'tradingAccounts.outro.create',
        },
      ],
    } as TourDefinition
  }, [enabled])

  return tour
}
